import { useMemo } from 'react';
import { GlobalSearchDocument } from './GlobalSearch.gql';
import { documentTransform } from './documentTransform';
/**
 * Hook to transform the GraphQL document based on the active columns.
 * This hook will memoize the transformed document based on the active columns.
 */
export function useTransformGraphqlDocument(columns) {
    const activeColumns = useMemo(() => columns
        .filter((col) => col.active)
        .map((col) => col.id)
        .sort(), [columns]);
    const queryDocument = useMemo(() => documentTransform({ columns: activeColumns }).transformDocument(GlobalSearchDocument), 
    // We need to use a stringified version of the array for memoization
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [activeColumns.join(',')]);
    return queryDocument;
}
